module.exports = __webpack_public_path__ + "static/media/download.55eb3585.svg";